import React from 'react';

const RegularHoursCandleNote = (
  <>
    <p>NOTE:</p>
    <p>
      The app can remain active outside regular equity market hours. Some
      candle-based setups and filters, however, are still aligned to
      regular-session candles unless the tactic explicitly says it uses
      pre-market or post-market data.
    </p>
    <p>
      For equity-style intraday examples here, that usually means candles are
      anchored from the 9:30 am Eastern regular-session open. Other platforms
      may label those candles differently if they include extended-hours data.
    </p>
  </>
);

export default RegularHoursCandleNote;
